import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import plusSymbol from "../../../assets/plus.png";
import downIcon from "../../../assets/down-icon.svg";
import searchIcon from "../../../assets/search-new-icon.svg";
import eyeIcon from "../../../assets/eye.svg";
import documentIcon from "../../../assets/document-icon.svg";
// import documentFolder from "../../../assets/card-pos.png";
import documentFolder from "../../../assets/revenueIcon.svg";
import editIcon from "../../../assets/edit-icon.svg";
import groupIcon from "../../../assets/grouping-icon.svg";
import CustomPagination from "../../../utils/paginationUtils";
import ViewProcedureModal from "./ViewProcedureModal";
import InactiveProcedureModal from "./InactiveProcedureModal";
import ProcedureDocumentMapping from "./ProcedureDocumentMapping";
import Switch from "@mui/material/Switch";
import Select from "react-select";
import { ProcedureFlowServices } from "../../../services/ProcedureFlowServices";
import { ReportServices } from "../../../services/ReportServices";
import { HospitalServices } from "../../../services/HospitalServices";
import { handleApiErrorResponses } from "../../../utils/ApisErrorHandling";
import { toast } from "react-toastify";
import { FilterDropdown } from "./FilterDropdown";
import { State } from "country-state-city";

function isTruthyMasterFlag(value) {
  if (value === true || value === 1) return true;
  if (value === false || value === 0 || value == null || value === "") return false;
  if (typeof value === "string") {
    const s = value.trim().toLowerCase();
    return s === "true" || s === "1" || s === "yes";
  }
  return false;
}

// const procedures = Array.from({ length: 12 }).map((_, i) => ({
//   scheme: i % 2 === 0 ? "PMJAY" : "CGHS",
//   specialtyId: "MG",
//   specialtyName: "Cardiology",
//   procedureId: `MG088${i}`,
//   procedureName:
//     i % 2 === 0
//       ? "Ventriculo - pleural Shunt (Low/Medium/High Pressure or Flow regulated valve)"
//       : "Pyogenic Meningitis",
//   state: i % 2 === 0 ? "Andhra Pradesh" : "All",
//   procedureStatus:
//     i % 4 === 0
//       ? "Complete & Freeze"
//       : i % 4 === 1
//         ? "Modified"
//         : i % 4 === 2
//           ? "Gov. Reserved"
//           : "Default",
//   status: "ACTIVE",
// }));

const getRowBg = (status) => {
  switch (status) {
    case "FREEZED":
      return {
        background:
          "linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(104, 255, 159, 0.6) 15%, rgba(104, 255, 159, 0.6) 82%, rgba(255, 255, 255, 0.6) 100%)",
      };

    case "Modified":
      return { backgroundColor: "#F3FFB9" };

    case "Gov. Reserved":
      return { backgroundColor: "#B9E0FF" };

    case "DEFAULTMAPPING":
      return {
        background:
          "linear-gradient(90deg, rgba(255, 255, 255, 0.6) 0%, rgba(232, 232, 232, 0.6) 15%, rgba(232, 232, 232, 0.6) 82%, rgba(255, 255, 255, 0.6) 100%)",
      };

    default:
      return {};
  }
};

export default function ManageProcedurePage() {
  const [page, setPage] = useState(1);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openView, setOpenView] = useState(false);
  const [openInactive, setOpenInactive] = useState(false);
  const [inactiveConfirmOnly, setInactiveConfirmOnly] = useState(false);
  const [procedureList, setProcedureList] = useState([]);
  const [procedureLoading, setProcedureLoading] = useState(false);
  const [inactiveLoading, setInactiveLoading] = useState(false);
  const [schemeList, setSchemeList] = useState([]);
  const [selectedScheme, setSelectedScheme] = useState(null);
  const [users, setUsers] = useState(null);
  const [hospitalList, setHospitalList] = useState([]);

  const [selectState, setSelectState] = useState("");
  const [selectProcedureStage, setSelectProcedureStage] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const searchDebounceRef = useRef(null);
  const navigate = useNavigate();
  const indianStates = State.getStatesOfCountry("IN").map(
    (state) => state.name,
  );
  const pageSize = 10;
  const procedureStageOptions = ["All", "DEFAULTMAPPING", "Modified", "Gov. Reserved", "FREEZED", "Completed"];
  const filteredByState = (procedureList ?? []).filter((p) => {
    if (!selectState || selectState === "All") return true;
    if (selectedScheme?.procedureCostMapping !== "STATE") return true;
    const rowState = (p.state ?? "").trim();
    return rowState === selectState || rowState === "All";
  });
  const filteredByProcedureStage = filteredByState.filter((p) => {
    if (!selectProcedureStage || selectProcedureStage === "All") return true;
    return (p.procedureStatus ?? "") === selectProcedureStage;
  });
  const paginatedProcedures = filteredByProcedureStage.slice(
    (page - 1) * pageSize,
    page * pageSize,
  );
  const totalPagesFiltered = Math.max(1, Math.ceil(filteredByProcedureStage.length / pageSize));

  const handleProcedureToggle = async (procedure) => {
    if (procedure.status === "ACTIVE") {
      setSelectedRow(procedure);
      setInactiveConfirmOnly(true);
      setOpenInactive(true);
      return;
    }

    // Going to ACTIVE → call API
    const schemeId = procedure?.schemeId;
    const procedureId = procedure?.procedureId;
    if (!schemeId || !procedureId) {
      toast.error("Cannot activate: missing scheme or procedure.");
      return;
    }
    setInactiveLoading(true);
    try {
      const res = await ProcedureFlowServices.updateProcedureSchemeMapping([
        { schemeId: String(schemeId), procedureId: String(procedureId), status: "ACTIVE" },
      ]);
      console.log("updateProcedureSchemeMapping (ACTIVE) response:", res);
      toast.success("Procedure activated successfully.");
      await fetchProcedures();
    } catch (err) {
      handleApiErrorResponses(err);
      toast.error("Failed to activate procedure. Please try again.");
    } finally {
      setInactiveLoading(false);
    }
  };

  const fetchSchemes = async () => {
    try {
      const res = await ProcedureFlowServices.getDefaultSchemeTypes({
        limit: 500,
      });
      const schemes = res?.data?.data || [];

      setSchemeList(schemes);

      // Default → ABHA (id = 2)
      const defaultScheme = schemes.find((s) => s.id === 2);
      if (defaultScheme) {
        setSelectedScheme(defaultScheme);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const getUsersDetails = async () => {
    try {
      const response = await ReportServices.getUsers();
      setUsers(response?.data?.users ?? null);
    } catch (err) {
      handleApiErrorResponses(err);
    }
  };

  const fetchHospitalList = async () => {
    try {
      const res = await HospitalServices.gethospitals("", 1, 1500);
      setHospitalList(res?.data?.list ?? []);
    } catch (err) {
      setHospitalList([]);
    }
  };

  useEffect(() => {
    fetchSchemes();
    getUsersDetails();
    fetchHospitalList();
  }, []);

  const fetchProcedures = async () => {
    if (!selectedScheme?.id) {
      setProcedureList([]);
      setProcedureLoading(false);
      return;
    }

    setProcedureList([]);
    setProcedureLoading(true);
    try {
      const baseParams = {
        schemeId: selectedScheme.id,
        procedureCostMapping: selectedScheme.procedureCostMapping || "STATE",
        procedureSchemeData: "ACTIVE",
        ...(selectState && selectState !== "All" && { costMappingId: selectState }),
        ...(searchKey.trim() && { searchKey: searchKey.trim() }),
      };

      const COST_LIST_PAGE_LIMIT = 100;
      let list = [];
      let pageNum = 1;
      let hasMore = true;
      const maxPages = 50;

      while (hasMore && pageNum <= maxPages) {
        const res = await ProcedureFlowServices.getSchemeProcedureCostList({
          ...baseParams,
          page: pageNum,
          limit: COST_LIST_PAGE_LIMIT,
        });
        const chunk = res?.data?.list ?? [];
        list = list.concat(chunk);
        const total = res?.data?.total;
        if (chunk.length === 0) {
          hasMore = false;
        } else if (typeof total === "number" && total >= 0 && list.length >= total) {
          hasMore = false;
        } else {
          hasMore = res?.data?.hasMore === true;
        }
        pageNum += 1;
      }

      const costMapping = selectedScheme?.procedureCostMapping || "STATE";
      const isHospital = String(costMapping).toUpperCase() === "HOSPITAL";
      const getStateOrHospitalDisplay = (costMappingId) => {
        if (!costMappingId) return "All";
        if (isHospital && hospitalList.length > 0) {
          const hosp = hospitalList.find(
            (h) =>
              String(h?.id ?? "") === String(costMappingId) ||
              String(h?.hospitalId ?? "") === String(costMappingId)
          );
          return hosp ? (hosp.name ?? hosp.hospitalName ?? costMappingId) : costMappingId;
        }
        return costMappingId;
      };

      const formattedList = list.map((item) => {
        const proc = item?.proceduresschememaster?.proceduremaster || {};
        const procStage = item?.proceduresschememaster?.procedureStage;
        const costMappingId = item?.costMappingId;

        return {
          scheme: selectedScheme.name || "",
          schemeId: selectedScheme?.id,
          procedureCostMapping: costMapping,
          costItemId: item?.id,
          costMappingId: costMappingId,
          procedureSchemeMasterId: item?.proceduresschememaster?.id,
          specialtyId: proc.specialityId || "",
          specialtyName: proc.speciality || "",
          procedureId: proc.procedureId || "",
          procedureName: proc.procedure || "",
          state: getStateOrHospitalDisplay(costMappingId),
          procedureStatus: procStage,
          status: item?.status || "ACTIVE",
          country: proc?.countryId,
          createdOn: proc?.createdAt,
          updatedOn: proc?.updatedAt,
          tierCost1: item?.tier1,
          tierCost2: item?.tier2,
          tierCost3: item?.tier3,
          implantName: item?.implants,
          createdBy: proc?.createdBy,
          updatedBy: proc?.updatedBy,
          isStratification: isTruthyMasterFlag(proc.isStratification),
          isImplant: isTruthyMasterFlag(proc.isImplant),
          /** Passed to cost-mapping edit so flags work without relying on a second list fetch */
          procedureMaster: proc,
          /** Full scheme-procedure-cost-list row — edit page uses when refetch returns a different page */
          costRowSnapshot: item,
        };
      });

      setProcedureList(formattedList);
    } catch (err) {
      console.error("Failed to fetch procedures", err);
      setProcedureList([]);
    } finally {
      setProcedureLoading(false);
    }
  };

  useEffect(() => {
    fetchProcedures();
  }, [selectedScheme, selectState, searchKey, hospitalList]);

  useEffect(() => {
    if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    searchDebounceRef.current = setTimeout(() => {
      setSearchKey(searchInput.trim());
      setPage(1);
    }, 400);
    return () => {
      if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
    };
  }, [searchInput]);

  useEffect(() => {
    setPage(1);
  }, [selectState, searchKey, selectProcedureStage]);
  const handleHeaderAction = (btn) => {
    if (btn === "Default Doc. Mapping") {
      navigate("/dashboard/default-doc-mapping");
      return;
    }

    if (btn === "Add New Procedure") {
      navigate("/dashboard/default-procedure-list", { state: { openAdd: true } });
      return;
    }

    // other buttons → placeholder for future logic
    if (btn === "Procedure Grouping") {
      navigate("/dashboard/procedure-mapping-page");
      return;
    }

    if (btn === "Cost Mapping") {
      // TODO: handle cost mapping
      console.log("Cost Mapping clicked");
      navigate("/dashboard/procedure-cost-mapping");
    }
  };

  const schemeOptions = schemeList.map((s) => ({
    value: s.id,
    label: s.name,
    procedureCostMapping: s.procedureCostMapping,
    childProcedureMapping: s.childProcedureMapping,
  }));

  const selectedSchemeOption = selectedScheme
    ? {
        value: selectedScheme.id,
        label: selectedScheme.name,
        procedureCostMapping: selectedScheme.procedureCostMapping,
      }
    : null;

  return (
    <div className="w-full min-h-screen min-h-[100dvh] flex flex-col">
      <div className="bg-[radial-gradient(81.98%_338.81%_at_13.41%_276.08%,_rgba(90,198,159,0.5)_0%,_rgba(222,222,222,0.5)_100%)] flex-1 min-h-full w-full p-3 sm:p-4 md:p-6">
        {/* ===== HEADER ===== */}
        <div className="px-3 sm:px-4 md:px-6 pt-4 sm:pt-6 md:pt-12 pb-0 mb-[30px] shadow-sm flex flex-col md:flex-row md:items-center md:justify-between gap-4 sm:gap-6 min-w-0">
          <h1 className="font-lufga font-normal text-[26px] sm:text-[32px] md:text-[36px] lg:text-[40px] xl:text-[44px] 2xl:text-[50px] leading-[100%] tracking-[-0.07em] text-black shrink-0">
          Procedure-Scheme
          </h1>

          <div className="flex flex-nowrap gap-1.5 sm:gap-2 md:gap-2 lg:gap-2.5 xl:gap-3 justify-start md:justify-end shrink-0 min-w-0 overflow-x-auto">
            {[
              "Default Doc. Mapping",
              "Cost Mapping",
              "Procedure Grouping",
              "Add New Procedure",
            ].map((btn) => (
              <button
                key={btn}
                onClick={() => handleHeaderAction(btn)}
                className="flex items-center gap-[6px] sm:gap-[8px] rounded-[54px] px-2.5 sm:px-3 md:px-3 lg:px-4 xl:px-4 2xl:px-[20px] 2xl:py-[16px] py-2 sm:py-2.5 md:py-2.5 lg:py-3 xl:py-3 border border-2 border-solid outline-none border-[#5AC69F] bg-[#5AC69FCC] font-lufga font-medium text-xs sm:text-[13px] md:text-[13px] lg:text-[14px] xl:text-[14px] 2xl:text-[16px] leading-[100%] tracking-[0] text-black hover:bg-[#5AC69F] transition-colors whitespace-nowrap flex-shrink-0"
              >
                <img
                  src={plusSymbol}
                  alt="plus"
                  className="w-3 h-3 sm:w-3 sm:h-3 xl:w-4 xl:h-4 flex-shrink-0"
                />
                <span className="hidden sm:inline">{btn}</span>
                <span className="sm:hidden">{btn.split(" ")[0]}</span>
              </button>
            ))}
          </div>
        </div>

        {/* ===== FILTERS ===== */}
        <div className="flex flex-col md:flex-row md:items-center gap-3 sm:gap-4 mb-[30px] min-w-0">
          {/* Search */}
          <div className="flex items-center gap-2 sm:gap-[8px] rounded-[54px] px-3 sm:px-4 md:px-[24px] py-2 sm:py-3 md:py-[14px] w-full md:min-w-[280px] md:flex-1 md:max-w-[720px] border-2 border-[#E8E8E899] bg-white min-w-0">
            <img
              src={searchIcon}
              alt="search"
              className="w-5 h-5 sm:w-6 sm:h-6 md:w-8 md:h-8 flex-shrink-0"
            />
            <input
              placeholder="Search by Procedure/Speciality Name"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
              className="w-full border-none outline-none bg-transparent font-lufga font-normal text-sm sm:text-base md:text-[16px] leading-[100%] tracking-[-0.05em] text-gray-700 placeholder-gray-400"
            />
          </div>

          {/* Scheme */}
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 w-full md:w-auto md:flex-shrink-0">
            <div className="w-full sm:w-auto sm:min-w-[180px] md:min-w-[200px]">
              <Select
                placeholder="Select Scheme"
                options={schemeOptions}
                value={selectedSchemeOption}
                isClearable={true}
                onChange={(item) => {
                  setPage(1);
                  if (!item) {
                    setSelectedScheme(null);
                    setProcedureList([]);
                    setSelectState("All");
                  } else {
                    const fullScheme = schemeList.find((s) => String(s.id) === String(item.value));
                    setSelectedScheme(fullScheme || {
                      id: item.value,
                      name: item.label,
                      procedureCostMapping: item.procedureCostMapping,
                      childProcedureMapping: item.childProcedureMapping,
                    });
                    setSelectState("All");
                  }
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    minHeight: "52px",
                    height: "52px",
                    borderRadius: "9999px",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    border: "2px solid #E8E8E899",
                    boxShadow: "none",
                    "&:hover": {
                      border: "2px solid #E8E8E899",
                    },
                  }),
                  valueContainer: (base) => ({
                    ...base,
                    padding: "0",
                    paddingLeft: "8px",
                  }),
                  input: (base) => ({
                    ...base,
                    margin: "0",
                    padding: "0",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#9CA3AF",
                    fontSize: "14px",
                  }),
                  singleValue: (base) => ({
                    ...base,
                    color: "#374151",
                    fontSize: "14px",
                  }),
                  indicatorSeparator: () => ({ display: "none" }),
                  dropdownIndicator: (base) => ({
                    ...base,
                    padding: "0 4px",
                  }),
                  clearIndicator: (base) => ({
                    ...base,
                    padding: "0 4px",
                  }),
                }}
              />
            </div>

            {/* State */}
            <div className="w-full sm:w-auto">
              <FilterDropdown
                placeholder="State"
                options={["All", ...indianStates]}
                value={selectState}
                setValue={setSelectState}
                enableSearch={true}
              />
            </div>

            {/* Procedure Stage */}
            <div className="w-full sm:w-auto">
              <FilterDropdown
                placeholder="Procedure Stage"
                options={procedureStageOptions}
                value={selectProcedureStage}
                setValue={setSelectProcedureStage}
                labelMap={{
                  DEFAULTMAPPING: "Default Mapping",
                  FREEZED: "Freezed",
                  "Gov. Reserved": "Gov. Reserved",
                  Modified: "Modified",
                  Completed: "Completed",
                }}
              />
            </div>
          </div>
        </div>

        {/* ===== TABLE ===== */}
        <div className="bg-white rounded-xl sm:rounded-2xl shadow-sm overflow-hidden">
          {/* ===== Desktop Table View (lg and above) ===== */}
          <div className="hidden lg:block overflow-x-auto">
            <div className="min-w-[1280px]">
              {/* Header row */}
              <div className="grid grid-cols-[1fr_0.8fr_1.5fr_1fr_1.8fr_1fr_1.5fr_300px] bg-white px-4 py-3 font-lufga font-semibold text-sm md:text-[14px] leading-[155%] tracking-[0] text-[#1B1B1B]">
                <div className="pr-2">Scheme</div>
                <div className="pr-2">Speciality ID</div>
                <div className="pr-2">Speciality Name</div>
                <div className="pr-2">Procedure ID</div>
                <div className="pr-2">Procedure Name</div>
                <div className="pr-2">State</div>
                <div className="pr-2">Procedure Status</div>
                <div className="text-center">Actions</div>
              </div>

              {/* ===== Rows ===== */}
              <div className="flex flex-col gap-2 p-2">
                {procedureLoading ? (
                  <div className="py-16 text-center text-gray-500 font-lufga">
                    Loading procedures...
                  </div>
                ) : paginatedProcedures.length === 0 ? (
                  <div className="py-16 text-center text-gray-500 font-lufga">
                    No procedures found.
                  </div>
                ) : (
                paginatedProcedures.map((p, i) => (
                  <div
                    key={i}
                    style={getRowBg(p.procedureStatus)}
                    className="grid grid-cols-[1fr_0.8fr_1.5fr_1fr_1.8fr_1fr_1.5fr_300px] items-center px-4 py-3 rounded-xl text-sm hover:shadow-md transition-shadow"
                  >
                    <div className="truncate pr-2">{p.scheme}</div>
                    <div className="truncate pr-2">{p.specialtyId}</div>
                    <div className="truncate pr-2">{p.specialtyName}</div>
                    <div className="truncate pr-2">{p.procedureId}</div>

                    <div className="truncate pr-2" title={p.procedureName}>{p.procedureName}</div>

                    <div className="truncate pr-2" title={p.state}>{p.state}</div>

                    <div className="truncate pr-2 font-medium">{p.procedureStatus}</div>

                    {/* Actions: toggle first, edit last; 300px column + nowrap — toggle was in its own 80px column before, so combined row needs more width than 220px */}
                    <div className="flex justify-center items-center gap-4 flex-nowrap shrink-0">
                      <Switch
                        checked={p.status === "ACTIVE"}
                        onChange={() => handleProcedureToggle(p)}
                        sx={{
                          "& .MuiSwitch-switchBase.Mui-checked": {
                            color: "#5AC69F",
                            "& + .MuiSwitch-track": { backgroundColor: "#5AC69F !important", opacity: 0.6 },
                          },
                          "& .MuiSwitch-track": {
                            backgroundColor: "#9e9e9e !important",
                          },
                        }}
                      />

                      <img
                        src={eyeIcon}
                        alt="view"
                        title="View Procedure"
                        className="w-5 h-5 cursor-pointer"
                        onClick={() => {
                          setSelectedRow(p);
                          setOpenView(true);
                        }}
                      />

                      <img
                        src={documentIcon}
                        alt="document-mapping"
                        title="Document Mapping"
                        className="w-4 h-4 cursor-pointer"
                        onClick={() =>
                          navigate("/dashboard/procedure-document-mapping", {
                            state: {
                              schemeId: p.schemeId,
                              scheme: p.scheme,
                              specialtyId: p.specialtyId,
                              specialtyName: p.specialtyName,
                              procedureId: p.procedureId,
                              procedureName: p.procedureName,
                            },
                          })
                        }
                      />

                      <img
                        src={documentFolder}
                        alt="cost-mapping"
                        title="Cost Mapping"
                        className="w-4 h-4 cursor-pointer"
                        onClick={() =>
                          navigate("/dashboard/procedure-cost-mapping-edited", {
                            state: {
                              procedureName: p.procedureName,
                              scheme: p.scheme,
                              schemeId: p.schemeId,
                              procedureCostMapping: p.procedureCostMapping,
                              costItemId: p.costItemId,
                              costMappingId: p.costMappingId,
                              state: p.state,
                              procedureId: p.procedureId,
                              specialtyName: p.specialtyName,
                              isStratification: p.isStratification,
                              isImplant: p.isImplant,
                              procedureMaster: p.procedureMaster,
                              costRowSnapshot: p.costRowSnapshot,
                            },
                          })
                        }
                      />

                      {selectedScheme?.childProcedureMapping && (
                        <img
                          src={groupIcon}
                          alt="group"
                          title="Procedure Grouping"
                          className="w-4 h-4 cursor-pointer"
                          onClick={() =>
                            navigate("/dashboard/procedure-mapping-page", {
                              state: {
                                schemeId: p.schemeId,
                                schemeName: p.scheme,
                                procedureSchemeMasterId: p.procedureSchemeMasterId,
                                procedureId: p.procedureId,
                                procedureName: p.procedureName,
                              },
                            })
                          }
                        />
                      )}

                      <img
                        src={editIcon}
                        alt="edit"
                        title="Edit Procedure"
                        className="w-4 h-4 cursor-pointer"
                        onClick={() =>
                          navigate("/dashboard/default-procedure-list", {
                            state: {
                              openEdit: true,
                              procedure: {
                                procedureId: p.procedureId,
                                procedure: p.procedureName,
                                specialityId: p.specialtyId,
                                speciality: p.specialtyName,
                                isStratification: p.isStratification,
                                isImplant: p.isImplant,
                              },
                            },
                          })
                        }
                      />
                    </div>
                  </div>
                ))
                )}
              </div>
            </div>
          </div>

          {/* ===== Mobile/Tablet Card View (below lg) ===== */}
          <div className="lg:hidden">
            <div className="flex flex-col gap-3 p-3 sm:p-4">
              {procedureLoading ? (
                <div className="py-16 text-center text-gray-500 font-lufga">
                  Loading procedures...
                </div>
              ) : paginatedProcedures.length === 0 ? (
                <div className="py-16 text-center text-gray-500 font-lufga">
                  No procedures found.
                </div>
              ) : (
              paginatedProcedures.map((p, i) => (
                <div
                  key={i}
                  style={getRowBg(p.procedureStatus)}
                  className="rounded-xl p-4 sm:p-5 hover:shadow-md transition-shadow space-y-3"
                >
                  {/* Header Row */}
                  <div className="flex items-start justify-between gap-3 pb-3 border-b border-gray-200">
                    <div className="flex-1 min-w-0">
                      <h3 className="font-lufga font-semibold text-base sm:text-lg text-[#1B1B1B] truncate" title={p.procedureName}>
                        {p.procedureName}
                      </h3>
                      <p className="font-lufga text-xs sm:text-sm text-gray-600 mt-1">
                        {p.procedureId}
                      </p>
                    </div>
                  </div>

                  {/* Details Grid */}
                  <div className="grid grid-cols-2 gap-3 sm:gap-4 text-sm">
                    <div>
                      <p className="font-lufga font-semibold text-xs text-gray-500 mb-1">
                        Scheme
                      </p>
                      <p className="font-lufga text-sm text-[#1B1B1B]">
                        {p.scheme}
                      </p>
                    </div>
                    <div>
                      <p className="font-lufga font-semibold text-xs text-gray-500 mb-1">
                        State
                      </p>
                      <p className="font-lufga text-sm text-[#1B1B1B] truncate" title={p.state}>
                        {p.state}
                      </p>
                    </div>
                    <div>
                      <p className="font-lufga font-semibold text-xs text-gray-500 mb-1">
                        Speciality ID
                      </p>
                      <p className="font-lufga text-sm text-[#1B1B1B]">
                        {p.specialtyId}
                      </p>
                    </div>
                    <div>
                      <p className="font-lufga font-semibold text-xs text-gray-500 mb-1">
                        Speciality Name
                      </p>
                      <p className="font-lufga text-sm text-[#1B1B1B]">
                        {p.specialtyName}
                      </p>
                    </div>
                    <div className="col-span-2">
                      <p className="font-lufga font-semibold text-xs text-gray-500 mb-1">
                        Procedure Status
                      </p>
                      <p className="font-lufga text-sm font-medium text-[#1B1B1B]">
                        {p.procedureStatus}
                      </p>
                    </div>
                  </div>

                  {/* Actions: toggle first, same middle order, edit last */}
                  <div className="flex items-center justify-start sm:justify-center gap-4 sm:gap-6 pt-3 border-t border-gray-200 flex-nowrap overflow-x-auto min-w-0">
                    <Switch
                      checked={p.status === "ACTIVE"}
                      onChange={() => handleProcedureToggle(p)}
                      size="small"
                      sx={{
                        "& .MuiSwitch-switchBase.Mui-checked": {
                          color: "#5AC69F",
                          "& + .MuiSwitch-track": { backgroundColor: "#5AC69F !important", opacity: 0.6 },
                        },
                        "& .MuiSwitch-track": {
                          backgroundColor: "#9e9e9e !important",
                        },
                      }}
                    />

                    <img
                      src={eyeIcon}
                      alt="view"
                      title="View Procedure"
                      className="w-5 h-5 sm:w-6 sm:h-6 cursor-pointer"
                      onClick={() => {
                        setSelectedRow(p);
                        setOpenView(true);
                      }}
                    />

                    <img
                      src={documentIcon}
                      alt="document-mapping"
                      title="Document Mapping"
                      className="w-5 h-5 sm:w-6 sm:h-6 cursor-pointer"
                      onClick={() =>
                        navigate("/dashboard/procedure-document-mapping", {
                          state: {
                            schemeId: p.schemeId,
                            scheme: p.scheme,
                            specialtyId: p.specialtyId,
                            specialtyName: p.specialtyName,
                            procedureId: p.procedureId,
                            procedureName: p.procedureName,
                          },
                        })
                      }
                    />

                    <img
                      src={documentFolder}
                      alt="cost-mapping"
                      title="Cost Mapping"
                      className="w-5 h-5 sm:w-6 sm:h-6 cursor-pointer"
                      onClick={() =>
                        navigate("/dashboard/procedure-cost-mapping-edited", {
                          state: {
                            procedureName: p.procedureName,
                            scheme: p.scheme,
                            schemeId: p.schemeId,
                            procedureCostMapping: p.procedureCostMapping,
                            costItemId: p.costItemId,
                            costMappingId: p.costMappingId,
                            state: p.state,
                            procedureId: p.procedureId,
                            specialtyName: p.specialtyName,
                            isStratification: p.isStratification,
                            isImplant: p.isImplant,
                            procedureMaster: p.procedureMaster,
                            costRowSnapshot: p.costRowSnapshot,
                          },
                        })
                      }
                    />

                    {selectedScheme?.childProcedureMapping && (
                      <img
                        src={groupIcon}
                        alt="group"
                        title="Procedure Grouping"
                        className="w-5 h-5 sm:w-6 sm:h-6 cursor-pointer"
                        onClick={() =>
                          navigate("/dashboard/procedure-mapping-page", {
                            state: {
                              schemeId: p.schemeId,
                              schemeName: p.scheme,
                              procedureSchemeMasterId: p.procedureSchemeMasterId,
                              procedureId: p.procedureId,
                              procedureName: p.procedureName,
                            },
                          })
                        }
                      />
                    )}

                    <img
                      src={editIcon}
                      alt="edit"
                      title="Edit Procedure"
                      className="w-5 h-5 sm:w-6 sm:h-6 cursor-pointer"
                      onClick={() =>
                        navigate("/dashboard/default-procedure-list", {
                          state: {
                            openEdit: true,
                            procedure: {
                              procedureId: p.procedureId,
                              procedure: p.procedureName,
                              specialityId: p.specialtyId,
                              speciality: p.specialtyName,
                              isStratification: p.isStratification,
                              isImplant: p.isImplant,
                            },
                          },
                        })
                      }
                    />
                  </div>
                </div>
              ))
              )}
            </div>
          </div>

          {/* ===== Pagination ===== */}
          {!procedureLoading && procedureList.length > 0 && (
            <div className="flex justify-center mt-4 sm:mt-6 mb-4 sm:mb-5 px-3">
              <CustomPagination
                page={page}
                setPage={setPage}
                totalPages={totalPagesFiltered}
              />
            </div>
          )}
        </div>
      </div>

      <ViewProcedureModal
        open={openView}
        onClose={() => setOpenView(false)}
        data={selectedRow}
        users={users}
      />

      <InactiveProcedureModal
        type={"Procedure"}
        open={openInactive}
        confirmLoading={inactiveLoading}
        onClose={() => {
          setOpenInactive(false);
          if (inactiveConfirmOnly) setSelectedRow(null);
        }}
        confirmOnly={inactiveConfirmOnly}
        onConfirm={async () => {
          const schemeId = selectedRow?.schemeId;
          const procedureId = selectedRow?.procedureId;
          if (!schemeId || !procedureId) {
            toast.error("Cannot inactive: missing scheme or procedure.");
            return;
          }
          setInactiveLoading(true);
          try {
            const res = await ProcedureFlowServices.updateProcedureSchemeMapping([
              { schemeId: String(schemeId), procedureId: String(procedureId), status: "INACTIVE" },
            ]);
            console.log("updateProcedureSchemeMapping (INACTIVE) response:", res);
            toast.success("Procedure inactivated successfully.");
            setOpenInactive(false);
            setSelectedRow(null);
            await fetchProcedures();
          } catch (err) {
            handleApiErrorResponses(err);
            toast.error("Failed to inactive procedure. Please try again.");
          } finally {
            setInactiveLoading(false);
          }
        }}
      />
    </div>
  );
}
